// redux/slices/mavisModalSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import AutoEditService from '../../services/autoEditService';
import UserService from '../../services/userService';
// import MavisService from '../../services/mavisService';
import { showMsg } from '../../services/library';
// import { EDITING_QUEUE } from '../../constants/messageConst';
import CommonService from '../../services/commonService';
import { EDITING_QUEUE } from '../../constants/messageConst';

// const _ = require('lodash');
// function arrayToIdObject(array, idProperty = 'id') {
//   return _.keyBy(array, idProperty);
// }

const setVehicleDetails = (state, action, isNewAPI = false) => {
  const payload = action.payload;

  let newStateData = [];
  let dealerName = '';
  let dealerhighlightNotes = [];
  let dealerNotes = [];
  let editNotes = [];
  let vehicleName = '';
  let vehicleType = '';
  let isPrelim = 0;
  let isVehReshoot = 0;
  let extColor = '-',
    intColor = '-',
    stock = '-';
  let isCertified = 0;
  let vehDate = '';

  let imageIndex;
  let dealerId;

  let editingQueueSenderName = '';
  let vehQueueChangedBy = null;
  if (isNewAPI) {
    imageIndex = payload.imageIndex;
    dealerId = payload.vehicle.dealer_userid;
  } else {
    imageIndex = payload.imageIndex;
    dealerId = payload.dealerId;
  }
  const { images = [], time, publishedMessage, isRecallAPI, currentQueue } = payload;

  images.forEach(e => {
    if (Object.keys(e).length !== 0) {
      let newData = {};
      if (e.isVds === false) {
        let autoMavis = e.autoMavis;
        const mavis = e.mavis;
        const vehicle = e.vehicle;
        const dlr = e.dealer;

        let imageBgRemove = mavis.dm_removebg === 1 ? true : false;
        let dm_removebg = mavis.dm_removebg;
        if (parseInt(vehicle.veh_ready) == 0 && parseInt(dlr.dealer_prelimremovebg) === 0) {
          imageBgRemove = false;
          dm_removebg = false;
        }
        dealerName = e.dealer.user_displayname;
        dealerNotes = e.dealer.dealer_notes ? e.dealer.dealer_notes.split('\n') : [];
        editNotes = e.vehicle.edit_notes ? e.vehicle.edit_notes.split('\n') : [];
        vehQueueChangedBy = e.vehicle.veh_queue_changed_by ? e.vehicle.veh_queue_changed_by : null;
        editingQueueSenderName = e.vehicle.photographerSendToEq ? e.vehicle.photographerSendToEq : '';
        dealerhighlightNotes = e.dealer.dealer_highlight_notes
          ? e.dealer.dealer_highlight_notes.split('\n')
          : [];
        vehicleName = e.vehicle.veh_name;
        vehDate = e.vehicle.veh_date;
        vehicleType = e.vehicle.veh_type;
        isPrelim =
          e.vehicle.veh_ready === 0 && e.vehicle.veh_reshoot === 0 && e.vehicle.veh_type === 'USED' ? 1 : 0;
        isVehReshoot = e.vehicle.veh_reshoot === 1 ? 1 : 0;

        extColor = e.vehicle.inv_ext_color || '-';
        intColor = e.vehicle.inv_int_color || '-';
        stock = e.vehicle.inv_stockno || '-';
        isCertified = e.vehicle.inv_certified || 0;
        newData = {
          img_id: e.image.img_id,
          veh_img_id: e.image.veh_img_id,
          key: e.image.key,
          checked: false,
          checkedForEditing: currentQueue === EDITING_QUEUE ? true : false,
          dealer: dealerId,
          veh_path: e.image.veh_thumb,
          veh_edited: e.image.veh_edited,
          veh_isreshoot: e.image.veh_isreshoot,
          veh_edited_local: false,
          veh_insta360: e.image.veh_insta360,
          veh_id: e.vehicle.veh_id,
          name_id: e?.shot?.name_id,
          name_text: e?.shot?.name_text,
          veh_path_main: e.image.veh_path,
          crop: false,
          applyColor: false,
          rotation: 0,
          rotationValChanged: false,
          tempRotation: 0,
          ratioCrop: true,
          name_crop: e?.shot?.name_crop,
          dm_isframe: mavis.dm_isframe,
          imageBgRemove,
          bgRemoveWithoutCrop: imageBgRemove,
          dm_removebg: dm_removebg,
          dm_frame: mavis.dm_frame,
          dm_uframe: mavis.dm_uframe,
          dm_cframe: mavis.dm_cframe,
          dm_frame_top: mavis.dm_frame_top,
          dm_frame_bottom: mavis.dm_frame_bottom,
          dm_uframe_top: mavis.dm_uframe_top,
          dm_uframe_bottom: mavis.dm_uframe_bottom,
          dm_cframe_top: mavis.dm_cframe_top,
          dm_cframe_bottom: mavis.dm_cframe_bottom,
          dm_dmsframe: mavis.dm_dmsframe,
          dm_is_dmsframe: mavis.dm_is_dmsframe,
          dm_dms_uframe: mavis.dm_dms_uframe,
          dm_dms_cframe: mavis.dm_dms_cframe,
          dm_dms_pframe: mavis.dm_dms_pframe,
          dm_bgid_new: mavis.dm_bgid_new,
          cropperData: null,
          cropperCanvas: null,
          shot_name: e?.shot?.name_text,
          reset: 0,
          guideline: e.guideline,
          thumb_guideline: e.thumb_guideline,
          mavisExample: e.image.mavisExample ? e.image.mavisExample : '',
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          xmin: 0,
          ymin: 0,
          xmax: 0,
          ymax: 0,
          resize: e.image.resize ? parseFloat(e.image.resize) : 0.0,
          isEdited: false,
          isOpened: false,
          isVds: e.isVds,
          im_croptype: autoMavis.im_croptype,
          im_training_data: autoMavis.im_training_data ? parseInt(autoMavis.im_training_data) : 0,
          filter: {
            autoexpo: autoMavis.im_autoexpo,
            shadows: autoMavis.im_shadows,
            highlights: autoMavis.im_highlights,
            coolwarm: autoMavis.im_coolwarm,
            sharpness: autoMavis.im_sharpness,
            brightness: autoMavis.im_brightness,
            contrast: autoMavis.im_contrast,
            hue: autoMavis.im_hue
          },
          colors: {
            smagenta: autoMavis.im_magentasatu,
            sblue: autoMavis.im_bluesatu,
            scyan: autoMavis.im_cyansatu,
            sgreen: autoMavis.im_greensatu,
            syellow: autoMavis.im_yellowsatu,
            sred: autoMavis.im_redsatu
          },
          lumanr: autoMavis.im_lumanr,
          chromanr: autoMavis.im_chromanr,
          detemphasis: autoMavis.im_detemphasis
        };
      } else {
        /* VDS Image Data */
        newData = {
          veh_img_id: e.veh_pimgid,
          veh_path: e.veh_path,
          checked: false,
          checkedForEditing: false,
          veh_edited: e.veh_edited,
          veh_isreshoot: e.veh_isreshoot,
          veh_edited_local: false,
          veh_insta360: e.veh_insta360,
          isVds: e.isVds,
          veh_pimgid: null,
          name_id: e?.shot?.name_id || null,
          name_text: e?.shot?.name_text || '',
          uniqId: '',
          parent: '',
          veh_path_main: '',
          shot_name: e?.shot?.name_text || '',
          imageBgRemove: false,
          bgRemoveWithoutCrop: false,
          dm_removebg: 0,
          dm_isframe: '',
          dm_frame: '',
          dm_frame_top: 0,
          dm_frame_bottom: 0,
          dm_uframe_top: 0,
          dm_uframe_bottom: 0,
          dm_cframe_top: 0,
          dm_cframe_bottom: 0,
          dm_uframe: '',
          dm_cframe: '',
          dm_dmsframe: '',
          mavisExample: '',
          name_crop: e?.shot?.name_crop,
          crop: false,
          applyColor: false,
          rotation: 0,
          rotationValChanged: false,
          tempRotation: 0,
          ratioCrop: true,
          cropperData: null,
          cropperCanvas: null,
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          xmin: 0,
          ymin: 0,
          xmax: 0,
          ymax: 0,
          resize: 0.0,
          isEdited: false,
          isOpened: false,
          im_croptype: 'no',
          im_training_data: 0,
          filter: {
            autoexpo: 0,
            shadows: 0,
            highlights: 0,
            coolwarm: 0,
            sharpness: 0,
            brightness: 0,
            contrast: 0,
            hue: 0
          },
          colors: { smagenta: 0, sblue: 0, scyan: 0, sgreen: 0, syellow: 0, sred: 0 }
        };
      }
      newStateData.push(newData);
    }
  });

  const index = newStateData.findIndex(x => x.veh_img_id === imageIndex);

  // const idBasedObject = arrayToIdObject(newStateData, 'img_id');

  state.data = newStateData;
  state.currentIndex = index >= 0 ? index : 0;
  state.startTime = time || Date.now();
  state.publishedMessage = publishedMessage || '';
  state.vehDetail = {
    dealerName: dealerName,
    vehicleName: vehicleName,
    extColor: extColor,
    intColor: intColor,
    vehicleType: vehicleType,
    stock: stock,
    dealerhighlightNotes: dealerhighlightNotes || [],
    dealerNotes: dealerNotes || [],
    editNotes: editNotes || [],
    isCertified: isCertified,
    isPrelim: isPrelim,
    isVehReshoot: isVehReshoot,
    vehicleDate: vehDate,
    editingQueueSenderName: editingQueueSenderName,
    vehQueueChangedBy: vehQueueChangedBy,
    isVdsVeh: images.some(f => f.vehicle.veh_vds === 1),
    vehIs43: images.some(f => f.vehicle.veh_is43 === 1)
  };

  const imageFilter = newStateData[index]?.filter || {};
  const newTemp = imageFilter.coolwarm > 100 || imageFilter.coolwarm < -100 ? 2 : 1;
  const newTint = imageFilter.hue > 100 || imageFilter.hue < -100 ? 2 : 1;

  state.temprature = newTemp;
  state.tint = newTint;
  state.isDataLoaded = true;
  // console.log('Mavis images fetched successfully', publishedMessage);
  if (publishedMessage.length > 0 && !isRecallAPI) {
    setTimeout(() => {
      window.alert(publishedMessage);
    }, 1000);
  }
};

export const fetchMavisImages = createAsyncThunk(
  'mavisModal/fetchMavisImages',
  async ({ dealerId, vehicleId, imageIndex, isRecallAPI, currentQueue }, thunkAPI) => {
    try {
      const response = await AutoEditService.vehicleDataAutoedit({
        dealer_id: dealerId,
        vehicle_id: vehicleId,
        mavis_open_from: currentQueue,
        is_ignore: 0,
        is_back_to_editing: 1
      });
      if (!response.status) {
        showMsg(response.errors, 'error');
        return thunkAPI.rejectWithValue(response);
      }
      return { ...response.data[0], imageIndex, dealerId, isRecallAPI, currentQueue };
    } catch (err) {
      showMsg(err.message, 'error');
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const fetchMavisQueue = createAsyncThunk(
  'mavisModal/fetchMavisQueue',
  async ({ currentQueue }, thunkAPI) => {
    try {
      const response = await CommonService.getEditorQueue({ queue: currentQueue });
      if (!response.status) {
        showMsg(response.errors, 'error');
        return thunkAPI.rejectWithValue(response);
      }
      return { ...response.data[0], isRecallAPI: true, currentQueue };
    } catch (err) {
      showMsg(err.message, 'error');
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const toggleGuideline = createAsyncThunk(
  'mavisModal/toggleGuideline',
  async ({ user_id, guideFlag }, thunkAPI) => {
    try {
      const response = await UserService.userSetGuideline({ user_id });
      if (response.status) {
        const newGuideFlag = !guideFlag;
        return newGuideFlag;
      } else {
        return thunkAPI.rejectWithValue(response.errors);
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const toggleDMSOverlayFlag = createAsyncThunk(
  'mavisModal/toggleDMSOverlayFlag',
  async ({ user_id, isDMSOverlayFlag }, thunkAPI) => {
    try {
      const response = await UserService.userSetGuideline({ user_id });
      if (response.status) {
        const newDMSOverlayFlag = !isDMSOverlayFlag;
        return newDMSOverlayFlag;
      } else {
        return thunkAPI.rejectWithValue(response.errors);
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const deleteEditorImage = createAsyncThunk(
  'mavisModal/deleteEditorImage',
  async ({ imageId, queue }, { rejectWithValue }) => {
    try {
      const response = await CommonService.deleteEditorImage({ img_id: imageId, queue });
      if (response.status) {
        return { imageId };
      } else {
        showMsg(response.errors, 'error');
        return rejectWithValue(response.errors);
      }
    } catch (err) {
      showMsg(err.message, 'error');
      return rejectWithValue(err);
    }
  }
);

const applyEditedCanvas = (state, canvas) => {
  const index = state.currentIndex;
  if (state.data[index].isEdited) {
    state.data[index].veh_path = canvas.toDataURL('image/jpeg');
    state.data[index].veh_edited_local = true;
  }
};

const initialState = {
  data: [
    {
      imageBgRemove: false,
      bgRemoveWithoutCrop: false,
      im_training_data: 0,
      dm_removebg: 0,
      veh_img_id: 0,
      checked: false,
      checkedForEditing: false,
      veh_path: '',
      veh_edited: 0,
      veh_isreshoot: 0,
      veh_edited_local: false,
      veh_insta360: 0,
      veh_pimgid: null,
      veh_id: 0,
      name_id: 0,
      name_text: '',
      uniqId: '',
      parent: '',
      veh_path_main: '',
      shot_name: '',
      dm_isframe: '',
      dm_frame: '',
      dm_frame_top: 0,
      dm_frame_bottom: 0,
      dm_uframe_top: 0,
      dm_uframe_bottom: 0,
      dm_cframe_top: 0,
      dm_cframe_bottom: 0,
      dm_uframe: '',
      dm_cframe: '',
      dm_is_dmsframe: 0,
      dm_dmsframe: '',
      dm_dms_uframe: '',
      dm_dms_cframe: '',
      dm_dms_pframe: '',
      guideline: '',
      mavisExample: '',
      name_crop: 'i',
      im_croptype: 'no',
      crop: false,
      applyColor: false,
      rotation: 0,
      rotationValChanged: false,
      tempRotation: 0,
      ratioCrop: true,
      cropperData: null,
      cropperCanvas: null,
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      xmin: 0,
      ymin: 0,
      xmax: 0,
      ymax: 0,
      resize: 0.0,
      isEdited: false,
      isOpened: false,
      isVds: false,
      filter: {
        autoexpo: 0,
        shadows: 0,
        highlights: 0,
        coolwarm: 0,
        sharpness: 0,
        brightness: 0,
        contrast: 0,
        hue: 0
      },
      colors: { smagenta: 0, sblue: 0, scyan: 0, sgreen: 0, syellow: 0, sred: 0 }
    }
  ],
  name: '',
  currentIndex: 0,
  vehDetail: {
    dealerName: '',
    vehicleName: '',
    extColor: '-',
    intColor: '-',
    vehicleType: '',
    vehicleDate: '',
    stock: '-',
    dealerhighlightNotes: [],
    dealerNotes: [],
    editNotes: [],
    isCertified: 0,
    isPrelim: 0,
    isVehReshoot: 0,
    isVdsVeh: false,
    vehIs43: false,
    editingQueueSenderName: '',
    vehQueueChangedBy: null
  },
  useNewCrop: false,
  isDataLoaded: false,
  imgLoading: false,
  errorWhileGetimage: false,
  isSaving: false,
  isPublishing: false,
  isSaved: false,
  isPublished: false,
  // flagDialouge: false,
  // flagData: 0,
  // flagMessage: [],
  manualCutoutDialouge: false,
  rejectVdsDialouge: false,
  manualCutoutNext: 'true',
  manualCutoutLoader: false,
  isAssistanceOpen: false,
  isSendToEditingModelOpen: false,
  isMavisExample: false,
  mavisExampleEvent: 'stop',
  temprature: 1,
  tint: 1,
  cropData: {},
  frameImg: '',
  guideFlag: false,
  isDMSOverlayFlag: true,
  isApplyEffects: false,
  publishedMessage: '',
  startTime: Date.now()
};

const mavisModalSlice = createSlice({
  name: 'mavisModal',
  initialState,
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    },
    setCurrentIndex: (state, action) => {
      state.currentIndex = action.payload;
    },
    setVehDetail: (state, action) => {
      state.vehDetail = action.payload;
    },
    setImgLoading: (state, action) => {
      state.imgLoading = action.payload;
    },
    setErrorWhileGetimage: (state, action) => {
      state.errorWhileGetimage = action.payload;
    },
    // setFlagDialouge: (state, action) => {
    //   state.flagDialouge = action.payload;
    // },
    // setFlagData: (state, action) => {
    //   state.flagData = action.payload;
    // },
    // setFlagMessage: (state, action) => {
    //   state.flagMessage = action.payload;
    // },
    setManualCutoutDialouge: (state, action) => {
      state.manualCutoutDialouge = action.payload;
    },
    setManualCutoutNext: (state, action) => {
      state.manualCutoutNext = action.payload;
    },
    setManualCutoutLoader: (state, action) => {
      state.manualCutoutLoader = action.payload;
    },
    setIsAssistanceOpen: (state, action) => {
      state.isAssistanceOpen = action.payload;
    },
    setIsSendToEditingModelOpen: (state, action) => {
      state.isSendToEditingModelOpen = action.payload;
    },
    setIsMavisExample: (state, action) => {
      state.isMavisExample = action.payload;
    },
    setMavisExampleEvent: (state, action) => {
      state.mavisExampleEvent = action.payload;
    },
    setTempratureVal: (state, action) => {
      state.temprature = action.payload;
    },
    setTintVal: (state, action) => {
      state.tint = action.payload;
    },
    setCropData: (state, action) => {
      state.cropData = action.payload;
    },
    setFrameImg: (state, action) => {
      state.frameImg = action.payload;
    },
    setGuideFlag: (state, action) => {
      state.guideFlag = action.payload;
    },
    setIsDMSOverlayFlag: (state, action) => {
      state.isDMSOverlayFlag = action.payload;
    },
    setIsApplyEffects: (state, action) => {
      state.isApplyEffects = action.payload;
    },
    setPublishedMessage: (state, action) => {
      state.publishedMessage = action.payload;
    },
    setStartTime: (state, action) => {
      state.startTime = action.payload;
    },
    setRejectVdsDialouge: (state, action) => {
      state.rejectVdsDialouge = action.payload;
    },

    thumbPreviewChange: (state, action) => {
      applyEditedCanvas(state, action.payload);
    },
    setIsSaving: (state, action) => {
      state.isSaving = action.payload;
    },
    setIsPublishing: (state, action) => {
      state.isPublishing = action.payload;
    },
    setIsSaved: (state, action) => {
      state.isSaved = action.payload;
    },
    setIsPublished: (state, action) => {
      state.isPublished = action.payload;
    },
    setUseNewCrop: (state, action) => {
      state.useNewCrop = action.payload;
    },

    nextButtonClick: (state, action) => {
      const { imgLoading, isMavisExample, currentIndex, data, isVdsVeh } = state;
      if (!imgLoading && !isMavisExample && currentIndex < data.length - 1) {
        applyEditedCanvas(state, action.payload);
        const index = currentIndex + 1;
        const temprature = data[index].filter.coolwarm > 100 || data[index].filter.coolwarm < -100 ? 2 : 1;
        const tint = data[index].filter.hue > 100 || data[index].filter.hue < -100 ? 2 : 1;
        if (data[index].isVds) {
          if (isVdsVeh) {
            showMsg(
              'There is no need to edit the VDS images, as they have already been processed.',
              'error',
              'bottom-right'
            );
          } else {
            showMsg(
              'Import image not found. Please delete the vehicle and try auto-editing again.',
              'error',
              'bottom-right'
            );
          }
        }
        state.imgLoading = true;
        state.currentIndex = index;
        state.temprature = temprature;
        state.tint = tint;
      }
    },

    prevButtonClick: (state, action) => {
      const { imgLoading, isMavisExample, currentIndex, data, isVdsVeh } = state;
      if (!imgLoading && !isMavisExample && currentIndex > 0) {
        applyEditedCanvas(state, action.payload);

        const index = currentIndex - 1;
        const temprature = data[index].filter.coolwarm > 100 || data[index].filter.coolwarm < -100 ? 2 : 1;
        const tint = data[index].filter.hue > 100 || data[index].filter.hue < -100 ? 2 : 1;

        if (data[index].isVds) {
          if (isVdsVeh) {
            showMsg(
              'There is no need to edit the VDS images, as they have already been processed.',
              'error',
              'bottom-right'
            );
          } else {
            showMsg(
              'Import image not found. Please delete the vehicle and try auto-editing again.',
              'error',
              'bottom-right'
            );
          }
        }

        state.imgLoading = true;
        state.currentIndex = index;
        state.temprature = temprature;
        state.tint = tint;
      }
    },

    thumbClick: (state, action) => {
      const { data } = state;
      const { final_canvas, index, fromCropper = false } = action.payload;
      applyEditedCanvas(state, final_canvas);

      const temprature = data[index].filter.coolwarm > 100 || data[index].filter.coolwarm < -100 ? 2 : 1;
      const tint = data[index].filter.hue > 100 || data[index].filter.hue < -100 ? 2 : 1;

      state.imgLoading = true;
      state.currentIndex = index;
      state.temprature = temprature;
      state.tint = tint;
      if (fromCropper) {
        state.data[index].crop = true;
      }
    },

    cropperThumbClick: (state, action) => {
      const { data } = state;
      const {
        // final_canvas,
        index
      } = action.payload;
      // applyEditedCanvas(state, final_canvas);
      const temprature = data[index].filter.coolwarm > 100 || data[index].filter.coolwarm < -100 ? 2 : 1;
      const tint = data[index].filter.hue > 100 || data[index].filter.hue < -100 ? 2 : 1;

      state.imgLoading = true;
      state.currentIndex = index;
      state.temprature = temprature;
      state.tint = tint;
      state.data[index].crop = true;
    },

    rotateSlideChange: (state, action) => {
      const { currentIndex } = state;
      const { rotation } = action.payload;
      if (state.data[currentIndex]) {
        state.data[currentIndex].rotation = rotation;
        state.data[currentIndex].rotationValChanged = true;
      }
    },

    bgRemoveWithoutCropChange: state => {
      const { currentIndex } = state;
      const bgRemoveWithoutCrop = !state.data[currentIndex].bgRemoveWithoutCrop;
      state.data[currentIndex].bgRemoveWithoutCrop = bgRemoveWithoutCrop;
      if (bgRemoveWithoutCrop === true) {
        state.data[currentIndex].isEdited = 1;
      }
    },
    ratioCropChange: (state, action) => {
      const { data, currentIndex, frameImg } = state;
      const val = action.payload;
      if (!data[currentIndex].isVds) {
        data[currentIndex].ratioCrop = val;
        data[currentIndex].isEdited = true;

        let cf = document.getElementsByClassName('cropper-face')[0];
        if (frameImg) {
          if (val) {
            cf.style.background = `url("${frameImg}?${Date.now()}") 100% / cover`;
            cf.style.opacity = '1 !important';
          } else {
            cf.style.background = 'transparent';
          }
        }
      }
    },

    handleCrop: state => {
      const { data, currentIndex } = state;
      if (!data[currentIndex].isVds) {
        const cropValue = !data[currentIndex].crop;
        state.data[currentIndex].crop = cropValue;
        if (cropValue === false && state.data[currentIndex].rotationValChanged) {
          state.data[currentIndex].rotation = state.data[currentIndex].tempRotation;
          state.data[currentIndex].rotationValChanged = false;
        }
        state.imgLoading = cropValue;
      }
    },
    handleCropperModal: state => {
      const { data, currentIndex } = state;
      if (!data[currentIndex].isVds) {
        state.data[currentIndex].crop = true;
        state.imgLoading = true;
      }
    },
    resetState: () => initialState
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMavisImages.pending, state => {
        state.isDataLoaded = false;
      })
      .addCase(fetchMavisImages.fulfilled, (state, action) => {
        setVehicleDetails(state, action);
      })
      .addCase(fetchMavisImages.rejected, state => {
        console.log('fetchMavisImages.rejected');
        state.isDataLoaded = false;
      })
      .addCase(fetchMavisQueue.pending, state => {
        state.isDataLoaded = false;
      })
      .addCase(fetchMavisQueue.fulfilled, (state, action) => {
        setVehicleDetails(state, action, true);
      })
      .addCase(fetchMavisQueue.rejected, state => {
        state.isDataLoaded = false;
      })
      .addCase(toggleGuideline.fulfilled, state => {
        const newGuideFlag = !state.guideFlag;
        state.guideFlag = newGuideFlag;
      })
      .addCase(toggleGuideline.rejected, (state, action) => {
        console.error('Toggle guideline failed:', action.payload);
      })
      .addCase(toggleDMSOverlayFlag.fulfilled, state => {
        const newDMSOverlayFlag = !state.isDMSOverlayFlag;
        state.isDMSOverlayFlag = newDMSOverlayFlag;
      })
      .addCase(toggleDMSOverlayFlag.rejected, (state, action) => {
        console.error('Toggle DMS Overlay failed:', action.payload);
      })
      .addCase(deleteEditorImage.pending, state => {
        state.imgLoading = true;
      })
      .addCase(deleteEditorImage.fulfilled, (state, action) => {
        const { imageId } = action.payload;
        const newData = state.data.filter(item => item.img_id !== imageId);
        const newIndex = state.currentIndex >= newData.length ? 0 : state.currentIndex;

        state.data = newData;
        state.currentIndex = newIndex;

        state.imgLoading = false;
      })
      .addCase(deleteEditorImage.rejected, action => {
        const errors = action.payload;
        showMsg(errors, 'error', 'bottom-right');
        // state.imgLoading = false;
      });
  }
});

export const {
  setData,
  setCurrentIndex,
  setVehDetail,
  setImgLoading,
  setErrorWhileGetimage,
  // setFlagDialouge,
  // setFlagData,
  // setFlagMessage,
  setManualCutoutDialouge,
  setManualCutoutNext,
  setManualCutoutLoader,
  setIsAssistanceOpen,
  setIsSendToEditingModelOpen,
  setIsMavisExample,
  setMavisExampleEvent,
  setTempratureVal,
  setRejectVdsDialouge,
  setTintVal,
  setCropData,
  setFrameImg,
  setGuideFlag,
  setIsDMSOverlayFlag,
  setIsApplyEffects,
  setPublishedMessage,
  setStartTime,
  resetState,
  thumbPreviewChange,
  prevButtonClick,
  nextButtonClick,
  thumbClick,
  cropperThumbClick,
  rotateSlideChange,
  bgRemoveWithoutCropChange,
  ratioCropChange,
  handleCrop,
  handleCropperModal,
  setIsSaving,
  setIsSaved,
  setIsPublishing,
  setIsPublished,
  setUseNewCrop
} = mavisModalSlice.actions;

export default mavisModalSlice.reducer;
